import 'react-toastify/dist/ReactToastify.min.css';
import Notifications from './utils/notification-helper';

require('./styles/main.scss');
import React from 'react';
import SkyTCAdminRouter from './router';
import ReactDOM from 'react-dom';
import { reaction } from 'mobx';
import { Provider } from 'mobx-react';
import App from './app-main/app';
import AppStore from './app-main/app-store';
import config from 'react-global-configuration';

const appStore = new AppStore();
const router = new SkyTCAdminRouter(appStore);
window.appStore = appStore;

//Initialization code
config.set(window.config);
window.Rollbar = window.Rollbar || { error: () => {} };
Notifications.initPromiseHandling();
ReactDOM.render(
    <Provider appStore={appStore}>
        <App />
    </Provider>,
    document.getElementById('root'),
    () => {
        router.init();
    }
);

const stonecutters = `

                 '.:/++oooo++/:.'                 
             ./shddddddddddddddddhs/.             
          -ohddddddddddddddddddddddddho-          
        /hddddddddddddddddddddddddddddddy/        
      :hddddddddddddddddddddyo+oddddddddddh:      
    'sdddddddddddddddddddy+////+hddddddddddds'    
   -dddddddddddddddddddddd++s+/+yhdddddddddddh-   
  -dddddddddddddddddddddddmddh+////sddddddddddd-  
 'hddddddddddddddddddddddddddd+/////+ddddddddddh' 
 +dddddddddddddddddddddddddddy///////sdddddddddd+ 
 ddddddddddddddddddddddddddyo///+so///mdddddddddd 
.mddddddddddd+mdddddddddyo///+shdddo//mdddddddddm.
-dddddddddddo/dddddddhs///+shddddddh/oddddddddddd-
.mdddddddddm//sdddds+///oydddddddddd+dddddddddddm.
 ddddddddddm///oso///oydddddddddddddddddddddddddd 
 +dddddddddds///////sddddddddddddddddddddddddddd+ 
 'hdddddddddd+/////+dddddddddddddddddddddddddddh' 
  .ddddddddddds/////hddmddddddddddddddddddddddd.  
   -hdddddddddddhy+/+s++dddddddddddddddddddddh.   
    'sdddddddddddho////+ymdddddddddddddddddds'    
      :hddddddddddo/oyddddddddddddddddddddh:      
        /hddddddddddddddddddddddddddddddh/        
          -odddddddddddddddddddddddddho-          
             -/shddddddddddddddddhs/.             
                 '-:/+oooooo+/:.'                                          
`
console.log(stonecutters); 



// WEBPACK FOOTER //
// ./src/index.js